// extracted by mini-css-extract-plugin
export default {"facet":"DropdownFacet_facet__oENT0","facetLabel":"DropdownFacet_facetLabel__XJglm"};